module.exports = __webpack_public_path__ + "static/media/Icon awesome-twitter.bd4537f9.svg";